module.exports = __webpack_public_path__ + "img/NDZ_Sticker.aa7410a4.png";